import React, { useState, useEffect } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons';

const Intro = ({ text = 'PortFolio', subtext="본 페이지는 비영리적 개인 포트폴리오 페이지입니다.일부 내용 및 이미지 등은 출처가 따로 있을 수 있습니다. 해상도 1920px 1080px 환경에 최적화 되어있습니다." ,speed = 100}) => {
  const [displayText, setDisplayText] = useState('');
  const [displaySubText, setDisplaySubText] = useState('');

  useEffect(() => {
    setDisplayText('');
    setDisplaySubText('');
    let i = 0;
    const maxLen= Math.max(text.length, subtext.length);
    const interval = setInterval(()=>{
      if(i< maxLen){
        setDisplayText(prev => prev + (text[i] || ''));
        setDisplaySubText(prev => prev + (subtext[i] || ''));
        i++;
      }else{
        clearInterval(interval);
      }
    },speed);

    return () => clearInterval(interval);
  }, [text, subtext, speed]);

  return (
    <section className="intro" id="Intro">
      <h2>{displayText}<span className='text_bar'>|</span></h2>
      {subtext && <h3 className='subtext'>{displaySubText}<span className='text_bar'>|</span></h3>}
      <div className='intro_text'>
        <p className='fade-in d1'>"Beyond</p>
        <p className='fade-in d2'>usability,</p>
        <p className='fade-in d3'>I create</p>
        <p className='fade-in d4'>visual delight."</p>
      </div>

      <div className='scroll-down'>
        <div className='mouse'>
          <div className='dot'></div>
          <div className='dot-bottom'></div>
        </div>
        <p>Scroll Down</p>
        <p><FontAwesomeIcon icon={faAngleDown} /></p>
      </div>
    </section>
  );
};

export default Intro;